<div class="container pt-2 pb-2">
  <div class="row">
    <div class="col-sm-12">
      <h3 class="text-center">
        <span class="highlight">Welcome to Corporate Portal </span>
        <button class="btn-link text-uppercase float-end close" (click)="close()">&times;</button>
      </h3>
      <p class="mt-4">
        Our team has been notified to provide with you the access to your Corporate investments. You will receive an email soon as this is
        provided, thank you!<br />
        <button class="btn-cancel m-t text-center btn-sm btn-shadow me-2 float-end" (click)="close()" type="button">Close</button>
      </p>
    </div>
  </div>
</div>
